import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'devices/remote',
    pathMatch: 'full',
  },
  {
    path: 'signed-in-redirect',
    pathMatch: 'full',
    redirectTo: 'devices/remote',
  },
  {
    path: 'folder/:id',
    loadChildren: (): any =>
      import('./pages/folder/folder.module').then(
        (m: any) => m.FolderPageModule
      ),
  },
  {
    path: 'about',
    loadChildren: (): any =>
      import('./pages/about/about.module').then((m: any) => m.AboutPageModule),
  },
  {
    path: 'guide',
    loadChildren: (): any =>
      import('./pages/guide/guide.module').then((m: any) => m.GuidePageModule),
  },
  {
    path: 'login',
    loadChildren: (): any =>
      import('./pages/login/login.module').then((m: any) => m.LoginPageModule),
  },
  {
    path: 'register',
    loadChildren: (): any =>
      import('./pages/register/register.module').then(
        (m: any) => m.RegisterPageModule
      ),
  },
  {
    path: 'forgot-password',
    loadChildren: (): any =>
      import('./pages/forgot-password/forgot-password.module').then(
        (m: any) => m.ForgotPasswordPageModule
      ),
  },
  {
    path: 'settings',
    loadChildren: (): any =>
      import('./pages/settings/settings.module').then(
        (m: any) => m.SettingsPageModule
      ),
  },
  // {
  //   path: 'create-device',
  //   loadChildren: (): any =>
  //     import('./pages/create-device/create-device.module').then(
  //       (m: any) => m.CreateDevicePageModule
  //     ),
  // },
  {
    path: 'devices',
    loadChildren: (): any =>
      import('./pages/device/device.module').then(
        (m: any) => m.DevicePageModule
      ),
  },
  {
    path: 'transactions',
    loadChildren: (): any =>
      import('./pages/transaction/transaction.module').then(
        (m: any) => m.TransactionPageModule
      ),
  },
  {
    path: 'tickets',
    loadChildren: (): any =>
      import('./pages/tickets/tickets.module').then(
        (m: any) => m.TicketsPageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
